<!-- eslint-disable-next-line vue/name-property-casing -->
<!-- eslint-disable vue/no-v-html -->
<template>
    <div>
        <div class="row g-3">
            <div class="col-md-6">
                <AppInput name="PolicyHolderDetail.SalutationId" :label="$root.t('step1.title')">
                    <AppSelect
                        v-model="form.salutationId"
                        :placeholder="$t('common.defaultSelectionValue')"
                        :options="$optionData.titles"
                    />
                </AppInput>
            </div>

            <div class="col-md-6">
                <AppInput name="PolicyHolderDetail.Forename" :label="$root.t('step1.forename')" rules="required">
                    <Input v-model="form.forename" class-name="form-control" auto-complete="given-name" />
                </AppInput>
            </div>

            <div class="col-md-6">
                <AppInput name="PolicyHolderDetail.Surname" :label="$root.t('step1.surname')" rules="required">
                    <Input v-model="form.surname" class-name="form-control" auto-complete="family-name" />
                </AppInput>
            </div>

            <div class="col-md-6">
                <AppInput name="PolicyHolderDetail.DateOfBirth" :label="$root.t('step1.dob')" rules="required">
                    <DropdownDatepicker
                        ref="dobDate"
                        v-model="form.dateOfBirth"
                        :min-age="minAge"
                        :max-age="maxAge"
                        :day-label="$t('common.day')"
                        :month-label="$t('common.month')"
                        :year-label="$t('common.year')"
                        @input="validateAgeRelationshipPolicy()"
                    />
                </AppInput>
            </div>
            <div class="col-md-6">
                <ValidationProvider v-slot="v" rules="genderId">
                    <AppInput name="PolicyHolderDetail.GenderId" :label="$root.t('step1.gender')" rules="required">
                        <AppSelect
                            v-model="form.genderId"
                            :placeholder="$t('common.defaultSelectionValue')"
                            :options="$optionData.genders"
                        />
                    </AppInput>
                    <span v-if="v.invalid" class="input-error" v-html="v.errors[0]" />
                </ValidationProvider>
            </div>

            <div class="col-md-6">
                <ValidationProvider v-slot="v" rules="occupationId">
                    <AppInput
                        name="PolicyHolderDetail.OccupationId"
                        :label="$root.t('step1.occupation')"
                        rules="required"
                    >
                        <AppSelect
                            v-model="form.occupationId"
                            :placeholder="$t('common.defaultSelectionValue')"
                            :options="$optionData.occupations"
                        />
                    </AppInput>
                    <span v-if="v.invalid" class="input-error" v-html="v.errors[0]" />
                </ValidationProvider>
            </div>

            <div class="col-md-6">
                <AppInput name="PolicyHolderDetail.JobTitle" :label="$root.t('step1.jobTitle')" rules="required">
                    <Input v-model="form.jobTitle" class-name="form-control" />
                </AppInput>
            </div>

            <div class="col-md-6">
                <AppInput name="PolicyHolderDetail.Industry" :label="$root.t('step1.industry')" rules="required">
                    <Input v-model="form.industry" class-name="form-control" />
                </AppInput>
            </div>

            <div class="col-md-12">
                <AppInput
                    name="PolicyHolderDetail.ResidenceCountryId"
                    :label="$root.t('step1.residenceCountry')"
                    rules="required"
                >
                    <AppSelect
                        v-model="form.residenceCountryId"
                        :options="$optionData.residenceCountries"
                        :placeholder="$t('common.defaultSelectionValue')"
                        searchable
                        @input="changeResidence"
                    />
                </AppInput>
            </div>

            <div class="col-md-12">
                <AppInput
                    name="PolicyHolderDetail.NationalityCountryId"
                    :label="$root.t('step1.nationalityCountry')"
                    rules="required"
                >
                    <AppSelect
                        v-model="form.nationalityCountryId"
                        :options="$optionData.nationalities"
                        :placeholder="$t('common.defaultSelectionValue')"
                        searchable
                        @input="changeCountry"
                    />
                </AppInput>
            </div>

            <div v-if="form.isTaxEnable" class="col-md-6">
                <AppInput
                    name="PolicyHolderDetail.TaxIdentificationNumber"
                    :label="$root.t('step1.tax')"
                    rules="required"
                >
                    <Input v-model="form.taxIdentificationNumber" class-name="form-control" />
                </AppInput>
            </div>
        </div>
    </div>
</template>

<script>
import AppSelect from '../shared/AppSelect.vue'
import DropdownDatepicker from '../shared/dropdown-datepicker'
import Input from '../shared/Input.vue'

import helper from '../../utils/helper.js'
import moment from 'moment'
export default {
    name: 'PolicyHolderDetail',
    components: {
        AppSelect,
        // eslint-disable-next-line vue/no-reserved-component-names
        Input,
        DropdownDatepicker,
    },
    data() {
        return {
            form: this.$formData.policyHolder.details,
            product: this.$formData.product,
            agePolicy: this.$agePolicyHolder,
            minAge: 18,
            maxAge: 74,
        }
    },
    mounted() {},
    methods: {
        validateAgeRelationshipPolicy() {
            let res = helper.validateAgePolicy(this.form.dateOfBirth, this.agePolicy.minAge, this.agePolicy.maxAge)
            if (!res.isValid) {
                this.$toast.open({
                    message: res.message,
                    type: 'error',
                })

                this.form.dateOfBirth = ''

                setTimeout(() => {
                    this.$refs.dobDate.clearData()
                }, 10)
            }
        },
        getValidateAgeByOccupation() {
            let res = helper.validateAgePolicy(this.form.dateOfBirth, this.agePolicy.minAge, this.agePolicy.maxAge)
            if (!res.isValid) {
                this.$toast.open({
                    message: res.message,
                    type: 'error',
                })

                this.form.dateOfBirth = ''

                setTimeout(() => {
                    this.$refs.dobDate.clearData()
                }, 10)
            }
        },
        changeResidence() {
            //enable TIN
            this.$formData.policyHolder.contactDetails.lineNumberCountryCodeId = this.form.residenceCountryId
            this.$formData.policyHolder.contactDetails.countryCodeMobileId = this.form.residenceCountryId

            var currentResidence = this.$optionData.residenceCountries.find(
                (c) => c.value === this.form.residenceCountryId,
            ).text
            if (currentResidence.toLowerCase().includes('portugal')) {
                this.form.isTaxEnable = true
            } else {
                this.form.isTaxEnable = false
            }

            // Save residence country
            this.$formData.policyHolder.additionalDetails.countryResidenceAddress.countryId =
                this.form.residenceCountryId
            this.$forceUpdate()

            //update tax info
        },
        changeCountry() {
            this.$formData.policyHolder.additionalDetails.homeCountryAddress.countryId = this.form.nationalityCountryId
            this.$forceUpdate()
        },
        checkFutureDate(date) {
            let today = moment().startOf('day')
            return moment(date).startOf('day') >= today
        },
        invalidDate() {
            this.$toast.open({
                message: 'Invalid format. Date format like date/month/year,',
                type: 'error',
            })
        },
    },
}
</script>
